import qs from 'qs';
import moment from 'moment';
import { postCSV } from 'utils/xhr';

import { fulfillmentUrl } from 'utils/wrappers';
import Base from 'app/models/base';
import Warehouse from 'app/models/fulfillment_warehouse';

export default Base.extend({
  urlRoot: fulfillmentUrl('bols', 'v2'),
  nestedModels: {
    warehouse: Warehouse,
  },

  last_item_received_at() {
    if (this.get('line_items')) {
      return Math.max.apply(null, this.get('line_items').map(item => (item.received_units ? item.updated_at : null)));
    }
    return false;
  },

  estimated_delivery() {
    if (this.get('estimated_delivery')) {
      return moment.unix(this.get('estimated_delivery')).format('YYYY-MM-DD');
    }
    return false;
  },

  uploadBolsCSV(options) {
    const query = {
      mode: this.get('apiModeSelection').getVal(),
      estimated_delivery: this.get('estimated_delivery'),
      warehouse_id: this.get('warehouse').get('id'),
      tracking_code: this.get('tracking_code'),
    };
    const url = `${this.urlRoot}?${qs.stringify(query)}`;
    const callback = {
      success: response => {
        this.set(this.parse(response));
        if (typeof options.success === 'function') {
          options.success();
        }
      },
    };
    postCSV({ url, ...options, ...callback });
  },
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_bol.js